import React, { useState } from 'react';

interface ExpandableContentProps {
  children: React.ReactNode;
  previewContent: React.ReactNode;
  buttonColor?: string;
  maxHeight?: string;
}

const ExpandableContent: React.FC<ExpandableContentProps> = ({ 
  children, 
  previewContent, 
  buttonColor = 'blue',
  maxHeight = 'auto'
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const getButtonClasses = (isExpanded: boolean) => {
    const baseClasses = "inline-flex items-center px-6 py-3 rounded-lg transition-colors duration-200 shadow-lg font-medium";
    
    if (isExpanded) {
      return `${baseClasses} bg-gray-600 text-white hover:bg-gray-700`;
    }
    
    const colorClasses = {
      blue: 'bg-blue-600 text-white hover:bg-blue-700',
      green: 'bg-green-600 text-white hover:bg-green-700',
      purple: 'bg-purple-600 text-white hover:bg-purple-700',
      red: 'bg-red-600 text-white hover:bg-red-700'
    };
    
    return `${baseClasses} ${colorClasses[buttonColor as keyof typeof colorClasses] || colorClasses.blue}`;
  };

  return (
    <div className="space-y-6">
      {/* Contenu de prévisualisation */}
      <div>{previewContent}</div>

      {/* Bouton Lire la suite */}
      {!isExpanded && (
        <div className="text-center">
          <button
            onClick={() => setIsExpanded(true)}
            className={getButtonClasses(false)}
          >
            <span className="mr-2">Lire la suite</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>
      )}

      {/* Contenu complet */}
      {isExpanded && (
        <div className="space-y-6">
          <div style={{ maxHeight: maxHeight, overflowY: maxHeight !== 'auto' ? 'auto' : 'visible' }}>
            {children}
          </div>
          
          {/* Bouton Voir moins */}
          <div className="text-center">
            <button
              onClick={() => setIsExpanded(false)}
              className={getButtonClasses(true)}
            >
              <span className="mr-2">Voir moins</span>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
              </svg>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExpandableContent;
